import { create } from 'zustand';

interface State {
    token: string | null;
    setToken: (d: string | null) => void;
}

export const useToken = create<State>(set => ({
    token: localStorage.getItem('token') || null,
    setToken: newToken => {
        set(state => {
            const token = state.token;

            if (newToken !== token) {
                window.queryClient.invalidateQueries({
                    queryKey: [],
                    exact: false,
                    type: 'all',
                    refetchType: 'all',
                    stale: true,
                });
            }

            if (!newToken) {
                localStorage.removeItem('token');
                return { ...state, token: newToken };
            }

            localStorage.setItem('token', newToken!);

            return { ...state, token: newToken };
        });
    },
}));
